import ProductIntroContainer from "@/containers/registration/ProductIntroContainer";

const ProductIntroPage = () => {
  return <ProductIntroContainer />;
};

export default ProductIntroPage;
